var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['element-input-label']},[_c('label',{class:['label-text', _vm.required ? 'required' : '']},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }